<template>
  <div class="subject-detail">
    <div class="container-fluid mt-1">
      <div class="row">
        <div class="col-xl-8 mb-5 mb-xl-0">
          <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
              <div class="col-sm-6">
                <h6 class="text-uppercase ls-1 mb-1">
                  Daftar Modul <span class="back-red-left">{{ subjectDetail.total_learning_activities }}</span>
                </h6>
              </div>
              <div class="col-sm-6 text-right" v-if="subjectDetail.is_admin">
                <b-button v-if="user.type == 'admin'" variant="primary" size="sm" @click="showModulFormModal(null)"><i class="fa fa-plus" aria-hidden="true"></i> Tambah Modul</b-button>
              </div>
            </div>
            <div v-if="subjectDetail.learning_activities && subjectDetail.learning_activities.length > 0" class="text-center text-muted">
              <b-table striped hover :items="subjectDetail.learning_activities" :fields="table.fields" thead-class="d-none">
                <template #cell(name)="data">
                  <router-link :to="{ name: 'modul-detail', params: { modulId: data.item.id, taId: taId } }" style="color: #212529" v-if="data.item.canOpen == 1 && data.item.is_current_modul == 1">
                    <div class="modul-name line-with-icon my-2">
                      <i class="fa fa-folder-open clr-red" aria-hidden="true"></i>
                      <span class="ml-1">
                        <b>{{ data.item.name }}</b>
                      </span>
                      <div class="ml-1 text-muted" style="font-size: 12px">
                        {{ data.item.created }}
                      </div>
                      <div v-if="data.item.isAdmin == '1'" class="ml-1 text-muted" style="font-size: 12px">
                        <span style="font-style: italic">{{ data.item.tanggal_terbit }}</span>
                      </div>
                    </div>
                  </router-link>
                  <div id="tooltip-target-1" class="modul-name line-with-icon my-2" v-else>
                    <i class="fa fa-lock" aria-hidden="true"></i>
                    <span class="ml-1">
                      <b>{{ data.item.name }}</b>
                    </span>
                    <div class="ml-1 text-muted" style="font-size: 12px">
                      <span style="font-style: italic">{{ data.item.view_date_range }}</span>
                    </div>
                    <div v-if="data.item.isAdmin == '1'" class="ml-1 text-muted" style="font-size: 12px">
                      <span style="font-style: italic">{{ data.item.tanggal_terbit }}</span>
                    </div>
                  </div>
                  <b-tooltip target="tooltip-target-1" triggers="hover" placement="bottom">
                    <span>Anda belum bisa membuka modul ini</span>
                  </b-tooltip>
                </template>
                <template #cell(actions)="data">
                  <div class="my-2" v-if="subjectDetail.is_admin">
                    <b-badge v-if="data.item.is_publish == '1'" variant="success">Published</b-badge>
                    <b-badge v-else variant="info">Draft</b-badge>
                    <a v-if="user.type == 'admin'" href="javascript:void(0)" class="icon-clicked p-1" @click="showModulFormModal(data.item)"><i class="fa fa-edit" aria-hidden="true"></i></a>
                    <a v-if="user.type == 'admin'" href="javascript:void(0)" class="icon-clicked p-1" @click="confirmDeleteModul(data.item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                  </div>
                </template>
              </b-table>
            </div>
            <div v-else class="p-2 text-center text-muted">Saat ini belum ada modul</div>
          </card>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header row align-items-center bg-transparent">
              <div class="d-flex justify-content-between" style="align-items: center">
                <div class="col">
                  <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                </div>
                <div>
                  <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                    <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'" @click="showMapelSettingFormModal"><i class="clr-red fa fa-cog" aria-hidden="true"></i>Pengaturan</b-dropdown-item>
                    <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'" @click="showCopyMapelSettingFormModal"><i class="clr-red fa fa-copy" aria-hidden="true"></i>Salin pelajaran</b-dropdown-item>
                    <b-dropdown-item
                      ><router-link :to="{ name: 'class-detail', params: { classId: subjectDetail.class_id } }" class="icon-clicked p-1"
                        ><i class="clr-red fa fa-arrow-left" aria-hidden="true"></i> Halaman Kelas</router-link
                      ></b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="identity px-2">
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ subjectDetail.user_name }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ subjectDetail.user_status }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-bookmark" aria-hidden="true"></i>{{ subjectDetail.class_name }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-book" aria-hidden="true"></i>{{ subjectDetail.name }}</p>
              </div>
            </div>
            <div class="card-footer">
              <div class="card">
                <div class="card-body text-center">
                  <h6>{{ subjectDetail.total_learning_activities }}</h6>
                  <h6>Modul</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="modul-form-modal" class="modul-form-modal" size="md" :title="setTitle" @show="resetModulForm" @hidden="resetModulForm" hide-footer no-close-on-backdrop>
      <modul-form :modulId="modulId" :modulList="modulList" :subjectId="subjectDetail.id" :modulDetail="modulDetail"></modul-form>
    </b-modal>
    <b-modal ref="mapel-setting-form-modal" class="mapel-setting-form-modal" size="md" title="Pengaturan Pelajaran" @show="resetMapelSettingForm" @hidden="resetMapelSettingForm" hide-footer no-close-on-backdrop>
      <div class="mapel-setting-form">
        <div>
          <b-form data-vv-scope="mapel-setting-form">
            <b-form-group label="Semester" label-for="semester" label-cols-sm="3" label-align-sm="left">
              <b-form-select v-model="mapel_setting_form.semester" name="semester" data-vv-as="Semester" :options="semesterList"></b-form-select>
              <span :class="{ 'error-validation': errors.first('mapel-setting-form.semester') }">{{ errors.first("mapel-setting-form.semester") }}</span>
            </b-form-group>
            <b-form-group label="Nama Mata Pelajaran" label-for="name" label-cols-sm="3" label-align-sm="left">
              <b-form-input
                id="input-nama-pelajaran"
                name="subject_name"
                data-vv-as="Nama mata pelajaran"
                v-model="mapel_setting_form.name"
                type="text"
                placeholder="Nama Mata Pelajaran"
                v-validate="'required'"
                autocomplete="off"
              ></b-form-input>
              <span :class="{ 'error-validation': errors.first('mapel-setting-form.subject_name') }">{{ errors.first("mapel-setting-form.subject_name") }}</span>
            </b-form-group>
          </b-form>
        </div>
        <hr />
        <div class="new-class-footer d-flex justify-content-end">
          <square-loader :loading="showLoaderMapelSetting" :color="'#ca062a'" :size="'30px'"></square-loader>
          <b-button v-if="!showLoaderMapelSetting" variant="outline-danger" size="md" style="width: 25%" @click="hideMapelSettingFormModal">BATAL</b-button>
          <b-button v-if="!showLoaderMapelSetting" variant="primary" size="md" style="width: 25%" @click.prevent="saveMapelSetting">SIMPAN</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="copy-mapel-setting-form-modal" class="copy-mapel-setting-form-modal" size="md" title="Salin Pelajaran" @show="resetCopyMapelSettingForm" @hidden="resetCopyMapelSettingForm" hide-footer no-close-on-backdrop>
      <div class="copy-mapel-setting-form">
        <div>
          <b-form data-vv-scope="copy-mapel-setting-form">
            <b-form-group label="Salin ke Kelas" label-for="name" label-cols-sm="3" label-align-sm="left">
              <b-form-select v-model="copy_mapel_setting_form.class_id" name="kelas" data-vv-as="Kelas" v-validate="'required'" :options="classList" value-field="id" placeholder="Kelas" text-field="name">
                <b-form-select-option :value="null" disabled>Please select an option</b-form-select-option>
              </b-form-select>
              <span :class="{ 'error-validation': errors.first('copy-mapel-setting-form.class_id') }">{{ errors.first("copy-mapel-setting-form.class_id") }}</span>
            </b-form-group>
          </b-form>
        </div>
        <hr />
        <div class="new-class-footer d-flex justify-content-end">
          <square-loader :loading="showLoaderCopyMapelSetting" :color="'#ca062a'" :size="'30px'"></square-loader>
          <b-button v-if="!showLoaderCopyMapelSetting" variant="outline-danger" size="md" style="width: 25%" @click="hideCopyMapelSettingFormModal">BATAL</b-button>
          <b-button v-if="!showLoaderCopyMapelSetting" variant="primary" size="md" style="width: 25%" @click.prevent="saveCopyMapelSetting">SALIN</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventBus.js";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";
import ModulForm from "../../../components/Main/Modul/ModulForm";
export default {
  props: {
    semesterList: {
      type: Array,
      default() {
        return [
          {
            value: "1",
            text: "Ganjil",
          },
          {
            value: "2",
            text: "Genap",
          },
        ];
      },
    },
  },
  components: {
    ModulForm,
    SquareLoader,
  },
  data() {
    return {
      showLoader: false,
      showLoaderMapelSetting: false,
      showLoaderCopyMapelSetting: false,
      modulId: null,
      setTitle: "",
      taId: this.$route.params.taId,
      table: {
        fields: [
          { key: "name", label: "Name", class: "text-left" },
          { key: "actions", label: "Actions", class: "action-column" },
        ],
      },
      modulList: [],
      modulDetail: {},
      mapel_setting_form: {
        id: null,
        name: null,
        class_id: null,
        user_id: null,
      },
      copy_mapel_setting_form: {
        id: null,
        class_id: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      subjectDetail: "getSubjectDetail",
      classList: "getClassList",
      currentSubjectId: "getCurrentSubjectId",
    }),
  },
  watch: {
    subjectDetail: {
      deep: true,
      async handler(newVal) {
        this.mapel_setting_form.id = newVal.id;
        this.mapel_setting_form.name = newVal.name_edit;
        this.mapel_setting_form.semester = newVal.semester;
        this.mapel_setting_form.class_id = newVal.class_id;
        this.mapel_setting_form.user_id = this.user.id;
        this.copy_mapel_setting_form.id = newVal.id;
        this.modulList = [];
        if (newVal.learning_activities && newVal.learning_activities.length > 0) {
          newVal.learning_activities.forEach((element) => {
            let obj = {
              value: element.id,
              text: element.name,
            };
            this.modulList.push(obj);
          });
          let nullData = {
            value: null,
            text: "-- Please select an option --",
          };
          this.modulList.push(nullData);
        }
      },
    },
  },
  methods: {
    showModulFormModal(param) {
      if (param) {
        this.modulId = param.id;
        this.modulDetail = param;
        this.setTitle = "Edit Modul";
      } else {
        this.modulDetail = {};
        this.modulId = null;
        this.setTitle = "Tambah Modul";
      }
      this.$refs["modul-form-modal"].show();
    },
    hideModulFormModal() {
      this.$refs["modul-form-modal"].hide();
      this.resetModulForm();
    },
    resetModulForm() {
      EventBus.$emit("resetModulForm", true);
    },
    showMapelSettingFormModal() {
      this.$refs["mapel-setting-form-modal"].show();
    },
    hideMapelSettingFormModal() {
      this.$refs["mapel-setting-form-modal"].hide();
      this.resetMapelSettingForm();
    },
    resetMapelSettingForm() {
      this.mapel_setting_form.id = this.subjectDetail.id;
      this.mapel_setting_form.name = this.subjectDetail.name_edit;
      this.mapel_setting_form.semester = this.subjectDetail.semester;
      this.mapel_setting_form.class_id = this.subjectDetail.class_id;
      this.mapel_setting_form.user_id = this.user.id;
    },
    showCopyMapelSettingFormModal() {
      this.$refs["copy-mapel-setting-form-modal"].show();
    },
    hideCopyMapelSettingFormModal() {
      this.$refs["copy-mapel-setting-form-modal"].hide();
      this.resetCopyMapelSettingForm();
    },
    resetCopyMapelSettingForm() {
      this.copy_mapel_setting_form.id = this.subjectDetail.id;
      this.copy_mapel_setting_form.class_id = null;
    },
    async saveMapelSetting() {
      let scope = "mapel-setting-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoaderMapelSetting = true;
          let form = this.mapel_setting_form;
          this.$store
            .dispatch("editSubject", form)
            .then((res) => {
              this.showLoaderMapelSetting = false;
              this.getSubjectDetail();
              this.hideMapelSettingFormModal();
              this.$swal.fire("Success", res.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoaderMapelSetting = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Failed", error.data.message, "error");
              }
            });
        }
      });
    },
    async saveCopyMapelSetting() {
      let scope = "copy-mapel-setting-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoaderCopyMapelSetting = true;
          let form = this.copy_mapel_setting_form;
          this.$store
            .dispatch("copySubject", form)
            .then((res) => {
              this.showLoaderCopyMapelSetting = false;
              this.$router.push({
                path: "/class-detail/" + this.copy_mapel_setting_form.class_id,
                params: {
                  classId: this.copy_mapel_setting_form.class_id,
                },
              });
              this.$swal.fire("Success", res.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoaderCopyMapelSetting = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Failed", error.data.message, "error");
              }
            });
        }
      });
    },
    async getSubjectDetail() {
      let subjectId = this.$route.params.subjectId;
      await this.$store
        .dispatch("getSubjectDetail", { subjectId })
        .then(() => {
          this.getClassList();
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getClassList() {
      let classId = this.subjectDetail.class_id;
      await this.$store
        .dispatch("getClassListSubject", { classId })
        .then(() => {})
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async confirmDeleteModul(modulId) {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.deleteModul(modulId);
          }
        });
    },
    async deleteModul(id) {
      await this.$store
        .dispatch("deleteModul", { id })
        .then((res) => {
          this.getSubjectDetail();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  created() {
    this.setCurrentSubjectId(this.$route.params.subjectId);
    this.getSubjectDetail();
    EventBus.$on("hideModulFormModal", (val) => {
      if (val) {
        this.hideModulFormModal();
      }
    });
  },
};
</script>
<style lang="css" scoped>
.modul-name:hover i,
.modul-name:hover span {
  color: #ca062a !important;
}
.btn-primary {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
}
.btn-primary:hover,
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:focus {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
</style>
